import { ChangeDetectionStrategy, Component, HostBinding, NgZone } from '@angular/core';
import { LMBusyIndicatorService, LMComponentInfoService, LMContextService, LMLoggerService } from '@app/services';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMApplicationMenuService } from '../services/lm-application-menu.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMGlobalPersonalizationService } from '../../../states/services/lm-global-personalization.service';
import { LMApplicationMenuSubMenuService } from '@components/applicationmenu/submenu/lm-application-menu-submenu.service';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMBrowserUtilService, LMContextUtilService, LMGlobalUtilService } from '@app/utils';
import { LMApplicationMenuTransactionService } from '../services/lm-application-menu-transaction.service';
import { LMApplicationMenuSubmenuBaseDirective } from '@components/applicationmenu/submenu/lm-application-menu-submenu-base.directive';
import { LMThemeService } from '@banner/lm-theme.service';

@Component({
  selector: 'lm-application-menu-submenu',
  templateUrl: 'lm-application-menu-submenu.component.html',
  styleUrls: [ 'lm-application-menu-submenu.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMApplicationMenuSubmenuComponent extends LMApplicationMenuSubmenuBaseDirective {
  constructor(
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmApplicationMenuTransactionService: LMApplicationMenuTransactionService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmSpecService: LMSpecService,
    protected lmContextService: LMContextService,
    protected lmContextUtilService: LMContextUtilService,
    protected routeComponent: LMRouteComponentService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmApplicationMenuSubMenuService: LMApplicationMenuSubMenuService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected ngZone: NgZone,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmBrowserUtil: LMBrowserUtilService,
    protected lmThemeService: LMThemeService
  ) {
    super(
      lmApplicationMenuService,
      lmApplicationMenuTransactionService,
      lmErrorUtilService,
      lmLoggerService,
      lmSpecService,
      lmContextService,
      lmContextUtilService,
      routeComponent,
      lmUrlUtilService,
      lmGlobalPersonalizationService,
      lmGlobalUtilService,
      lmApplicationMenuSubMenuService,
      lmBusyIndicatorService,
      ngZone,
      lmComponentInfoService,
      lmBrowserUtil,
      lmThemeService
    );
  }
}
